import React, { createContext, useState, useContext, useEffect } from 'react';

const DistanceUnitContext = createContext(undefined);

export const useDistanceUnit = () => {
  const context = useContext(DistanceUnitContext);
  if (context === undefined) {
    throw new Error('useDistanceUnit must be used within a DistanceUnitProvider');
  }
  return context;
};

export const DistanceUnitProvider = ({ children }) => {
  const [unit, setUnit] = useState(() => {
    // Load from localStorage or default to miles
    return localStorage.getItem('distanceUnit') || 'miles';
  });

  useEffect(() => {
    // Save to localStorage whenever unit changes
    localStorage.setItem('distanceUnit', unit);
  }, [unit]);

  const toggleUnit = () => {
    setUnit(prevUnit => prevUnit === 'miles' ? 'km' : 'miles');
  };

  const convertDistance = (meters) => {
    if (!meters) return 0;
    if (unit === 'miles') {
      return (meters / 1609.34).toFixed(2);
    } else {
      return (meters / 1000).toFixed(2);
    }
  };

  const getUnitLabel = () => {
    return unit === 'miles' ? 'mi' : 'km';
  };

  const value = {
    unit,
    setUnit,
    toggleUnit,
    convertDistance,
    getUnitLabel
  };

  return (
    <DistanceUnitContext.Provider value={value}>
      {children}
    </DistanceUnitContext.Provider>
  );
};
